import React from "react";
import ButtonWithText from "./Button";

/**
 * An option with `disabled: true` looks like a disabled button but stays clickable, so the screen can
 * say why it is not available: the click goes to `onDisabledClick` instead of `setSelected`. A real
 * `disabled` attribute would swallow the click and leave the user with no explanation.
 */
const Options = ({ selected, setSelected, options, onDisabledClick, ...props }) => {
    return (
        <div className="d-flex" style={{ gap: "8px" }}>
            {options.map((option, index) => (
                <ButtonWithText
                    variant={option.value === selected ? option.activeVariant : "passive"}
                    leftIcon={option.value === selected ? "check" : undefined}
                    buttonStyle={option.value === selected ? "selectedOption" : "option"}
                    size="option"
                    key={index}
                    onClick={(e) => {
                        e.preventDefault();
                        if (option.disabled) {
                            if (onDisabledClick) onDisabledClick(option.value);
                            return;
                        }
                        setSelected(option.value);
                    }}
                    {...(option.disabled && {
                        "aria-disabled": true,
                        // Same look as the kit's own disabled button.
                        style: { cursor: "not-allowed", opacity: 0.6 },
                    })}
                    {...props}
                >
                    {option.label}
                </ButtonWithText>
            ))}
        </div>
    );
};

export default Options;
